export default {"src":"/_next/static/media/glitterYellow.8efbe8e9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};